// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1D-7M","signatureBlock":"Footer_signatureBlock__3Zsse","signature":"Footer_signature__qAHpN"};